<template>
  <div class="bg-white rounded-2xl shadow-md p-6">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField label="Identifiant" :value="String(billingEntity.id)" />
      <StackedField label="Raison sociale" :value="billingEntity.businessName" />
      <StackedField label="Adresse de facturation" :value="billingEntity.billingAddress" />
      <StackedField label="IBAN" :value="billingEntity.iban || '-'" />
      <StackedField
        v-if="billingEntity.mandate"
        label="Mandat de prélèvement"
        :value="$t(`mandate.status.${billingEntity.mandate.status}`)"
      />
      <StackedField
        v-if="billingEntity.mandate?.responsibleEmail"
        label="Email du demandeur"
        :value="billingEntity.mandate.responsibleEmail"
      />
      <StackedField v-if="mandateActive" label="Référence du mandat" :value="billingEntity.mandate.referenceId" />
      <StackedField v-if="mandateToSetup" label="Lien d'activation du mandat">
        <a
          :href="billingEntity.mandate.authorizationUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="text-blue-400 underline"
        >
          Lien
        </a>
      </StackedField>
    </div>
  </div>
</template>

<script>
import { StackedField } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  components: { StackedField },
  props: {
    billingEntity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("mandates", ["isMandateActive", "isMandateToSetup"]),
    mandateToSetup() {
      return this.isMandateToSetup(this.billingEntity.mandate);
    },
    mandateActive() {
      return this.isMandateActive(this.billingEntity.mandate);
    },
  },
};
</script>
